<template>
  <form class="printed-folio-request-form" @submit.prevent="handleFormSubmit">
    <form-group
      v-if="showOrganizationPicker"
      label="Organización"
      :errors="errors"
      error-key="organization_rut">
      <select
        id="range-organization"
        v-model="form.data.organization_rut"
        class="form-control"
        name="range-organization">
        <option :value="null">
          - Selecciona la organización -
        </option>
        <option v-for="organization in organizations" :key="organization.rut" :value="organization.rut">
          {{ organization.name }}
        </option>
      </select>
    </form-group>
    <ul v-if="allowRequestRange" class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: requestType ==='amount'}"
          href="#"
          @click.prevent="handleRequestTypeChange('amount')">Cantidad</a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          :class="{active: requestType ==='range'}"
          href="#"
          @click.prevent="handleRequestTypeChange('range')">Rango</a>
      </li>
    </ul>
    <template v-if="requestType === 'amount'">
      <form-group
        :label="`${amountTextPrefix}Cantidad de folios a solicitar:`"
        for-id="amount"
        error-key="amount"
        :errors="errors">
        <input
          ref="amount-input"
          v-model="form.data.amount"
          type="number"
          min="0"
          class="form-control">
      </form-group>
    </template>
    <template v-if="requestType === 'range'">
      <form-group
        label="Rango"
        for-id="range-start"
        error-key="range"
        :errors="errors">
        <div class="row">
          <div class="col-12" />
          <div class="col-sm-6">
            <app-folio-input
              id="range-start"
              v-model="form.data.range.start"
              placeholder="Rango Inicial"
              class="form-control" />
          </div>
          <div class="col-sm-6">
            <app-folio-input
              id="range-end"
              v-model="form.data.range.end"
              placeholder="Rango Final"
              class="form-control" />
          </div>
        </div>
      </form-group>
    </template>
    <div class="row printed-folio-request-form__footer">
      <div class="col-12">
        <button class="btn btn-primary" type="submit" :disabled="processing">
          Guardar
        </button>
      </div>
    </div>
  </form>
</template>
<script>
import FormGroup from '@/components/FormGroup';
import _get from 'lodash/get';
import AppFolioInput from '../AppFolioInput';

export default {
  name: 'PrintedFolioRequestForm',
  components: {
    AppFolioInput,
    FormGroup
  },
  props: {
    printedFolioRequest: {
      type: Object,
      required: true
    },
    printedFolioRequests: {
      type: Array,
      default() {
        return [];
      }
    },
    errors: {
      type: Object,
      default() {
        return {};
      }
    },
    processing: {
      type: Boolean,
      default: false
    },
    organizations: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      allowRequestRange: false,
      requestType: 'amount',
      form: {
        data: {
          organization_rut: null,
          range: {
            start: _get(this.printedFolioRequest, 'range.start', ''),
            end: _get(this.printedFolioRequest, 'range.end', '')
          },
          amount: 0
        }
      }
    };
  },
  computed: {
    showOrganizationPicker() {
      return this.type === 'medical_center';
    },
    amountTextPrefix() {
      if (this.latestRequestedFolio) {
        return `Último folio solicitado: <strong>${this.latestRequestedFolio}</strong><br/>`;
      }
      return '';
    },
    latestRequestedFolio() {
      if (!this.showOrganizationPicker) {
        return _get(this.printedFolioRequests, '0.folio_end', '0');
      }
      if (!this.form.data.organization_rut) {
        return '-';
      }
      const cleanOrganizationRut = this.form.data.organization_rut.replace('-', '');
      const latestRequest = this.printedFolioRequests.find(p => p.organization_rut === cleanOrganizationRut);
      return latestRequest ? latestRequest.folio_end : '-';
    }
  },
  mounted() {
    if (this.$refs['amount-input']) {
      this.$refs['amount-input'].focus();
    }
  },
  methods: {
    handleRequestTypeChange(requestType) {
      this.requestType = requestType;
    },
    handleFormSubmit() {
      const formData = JSON.parse(JSON.stringify(this.form.data));
      if (this.requestType === 'amount') {
        delete formData.range;
      } else {
        delete formData.amount;
      }
      this.$emit('submit', formData);
    }
  }
};
</script>

<style lang="scss">
.printed-folio-request-form {
  &__footer {
    > div {
      display: flex;
      justify-content: flex-end;
    }
  }

  .nav-tabs {
    margin-bottom: $--spacing-3;
    border-bottom: 1px solid #dee2e6!important;
  }
}
</style>
